import React from 'react'
import classnames from 'classnames'
import { Icon } from 'components'

export default class Dropdown extends React.Component {
  state = {
    open: false,
    selectedItemIndex: this.props.defaultItem || 0,
  }

  toggleMenu = () =>
    this.setState(
      prevState => ({ open: !prevState.open }),
      () =>
        this.state.open
          ? document.addEventListener('click', this.handleOutsideClick, false)
          : document.removeEventListener(
              'click',
              this.handleOutsideClick,
              false
            )
    )

  handleOutsideClick = () => this.toggleMenu()

  renderMenu = (items, selectedIndex, handleUpdate) => (
    <div className="dropdown__menu">
      <div className="dropdown__arrow" />
      {items.map((item, idx) => (
        <div
          key={idx}
          className={classnames('dropdown__item', {
            'dropdown__item--active': idx === selectedIndex,
          })}
          onClick={() => {
            handleUpdate && handleUpdate(item.value)
            this.setState({ selectedItemIndex: idx })
          }}
        >
          <span>{item.label}</span>
          <span>{item.description}</span>
        </div>
      ))}
    </div>
  )

  render() {
    const { label, message, menuItems, handleUpdate } = this.props
    const { open, selectedItemIndex } = this.state
    const classNames = classnames('dropdown', {
      'dropdown--open': open,
    })
    return (
      <div className={classNames}>
        {label && <label>{label}</label>}
        <div className="dropdown__button" onClick={() => this.toggleMenu()}>
          <div>{menuItems[selectedItemIndex].label}</div>
          <Icon name="angle-down-black" />
        </div>
        {open && this.renderMenu(menuItems, selectedItemIndex, handleUpdate)}
        {message && <label>{message}</label>}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/Dropdown.js